import * as tracking from './reco-widget/tracking'
import { getCookieByName } from 'js/bankrate-utilities'

const allowedOrigins = [
  'https://deposits-bank-reco-widget.qa.bankrate.com',
  'https://deposits-bank-reco-widget.bankrate.com'
]

// Checks if origin starts with any of the allowed origins.
export const isOriginAllowed = origin =>
  allowedOrigins.some(allowedOrigin => origin.startsWith(allowedOrigin))

export const isObject = val => val !== null && typeof val === 'object'

const getMessageTargetOrigin = () => {
  if (window.env === 'local') return '*'
  if (['qa', 'staging'].includes(window.env))
    return 'https://deposits-bank-reco-widget.qa.bankrate.com'
  return 'https://deposits-bank-reco-widget.bankrate.com'
}

export const sendMessage = message => {
  const iFrame = document.getElementById('deposits-reco-widget')

  if (!iFrame) {
    console.error('iFrame with id, "deposits-reco-widget", not found.')
    return
  }

  iFrame.contentWindow.postMessage(message, getMessageTargetOrigin())
}

function receiveMessage(event) {
  const { origin, data } = event

  if (window.env !== 'local' && !isOriginAllowed(origin)) return
  if (!isObject(data) || !data.type) return

  switch (data.type) {
    case 'reco-widget.READY': {
      const token = getCookieByName('BAEAU')

      sendMessage({
        type: 'reco-widget.BOOTSTRAP',
        value: { token }
      })

      break
    }
    case 'reco-widget.HEIGHT_UPDATED': {
      const height = data.value
      const iFrame = document.getElementById('deposits-reco-widget')
      iFrame.style.height = `${height}px`

      break
    }
    case 'reco-widget.RESULTS': {
      // Currently we only want to show results on the
      // Recommendation hub page and the authenticated dashboard,
      // NOT ratetables or articles
      const shouldShowResults = window.location.pathname.match(
        /(\/)?(app\/dashboard|bank-recommendation)(\/)?/g
      )

      if (shouldShowResults) {
        sendMessage({
          type: 'reco-widget.SHOULD_SHOW_RESULTS',
          value: true
        })
      } else {
        sendMessage({
          type: 'reco-widget.SHOULD_SHOW_RESULTS',
          value: false
        })
      }

      break
    }
    case 'reco-widget.TAGULAR_EVENT': {
      tracking.sendRecoWidgetTagularEvent(data.value)

      break
    }
  }
}

window.addEventListener('message', receiveMessage, false)
